var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.3329V6.66626C16.4997 6.37399 16.4225 6.08693 16.2763 5.8339C16.13 5.58086 15.9198 5.37073 15.6667 5.22459L9.83333 1.89126C9.57997 1.74498 9.29256 1.66797 9 1.66797C8.70744 1.66797 8.42003 1.74498 8.16667 1.89126L2.33333 5.22459C2.08022 5.37073 1.86998 5.58086 1.72372 5.8339C1.57745 6.08693 1.5003 6.37399 1.5 6.66626V13.3329C1.5003 13.6252 1.57745 13.9123 1.72372 14.1653C1.86998 14.4183 2.08022 14.6285 2.33333 14.7746L8.16667 18.1079C8.42003 18.2542 8.70744 18.3312 9 18.3312C9.29256 18.3312 9.57997 18.2542 9.83333 18.1079L15.6667 14.7746C15.9198 14.6285 16.13 14.4183 16.2763 14.1653C16.4225 13.9123 16.4997 13.6252 16.5 13.3329Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonIcon);
export default __webpack_public_path__ + "static/media/polygon-icon.6ab7ad54588d9449042084ce7af62bde.svg";
export { ForwardRef as ReactComponent };